import React from "react";
import SectionTitle from "../../../components/sectionTitle";
import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function CustomerEkycMismatch({
  classes: {},
  form,
  onClickHandler,
  handleClose,
  modal,
}) {
  return (
    <Dialog
      onClose={() => handleClose("mismatch", false)}
      aria-labelledby="simple-dialog-title"
      open={modal.mismatch}
      maxWidth={"md"}
    >
      <DialogTitle id="simple-dialog-title">
        <SectionTitle title={"e-KYC Response"} />
      </DialogTitle>
      <Box m={1}>
        <Box p={1}>
          <Typography variant="caption">{form.mismatch}</Typography>
        </Box>
        <Box mt={3}>
          <Button
            type={"button"}
            variant={"contained"}
            color={"primary"}
            size={"small"}
            onClick={onClickHandler}
            fullWidth
          >
            Restart Journey
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomerEkycMismatch);
